import "./footer.css";

export default function Footer() {
    return (
        <footer>
            <div className="footer-legal-container">
                <p className="fs-md mb-0"><span>© All rights reserved. Property of </span><a className="d-inline fw-normal p-0" href="./" target="_blank" rel="noopener">Dev4.online</a></p>
                <a target="_blank" rel="noreferrer" href="./">Privacy Policy</a>
            </div>
            <aside>
                <a className="icon-circle-btn" target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/dev4-online/">
                    <i className="ai-linkedin"></i>
                </a>

                <a className="icon-circle-btn" target="_blank" rel="noreferrer" href="https://www.facebook.com/dev4.online/">
                    <i className="ai-facebook"></i>
                </a>
            </aside>
        </footer>   
    )
}